module.exports = __webpack_public_path__ + "media/images/product_lines/i1-c659e0b0fba4db42c2d540db4be8f8fd.svg";